export default "__VITE_ASSET__Bdu8_Nof__"